// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
import consts from "@/consts";
import range from "lodash/range";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        shipmentsPackagesFullLoad: false,
        shipmentsPackagesLiteLoad: false,
        shipmentsPackages: [],
    },
    actions: {
        fetchShipmentsPackagesAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isShipmentsPackagesLiteLoad) {
                    return resolve(getters.getShipmentsPackages.length)
                }
                this.$api.init.getShipmentsPackages()
                    .then((response) => {
                        if (response.status < 400 && response.data?.shipments_packages) {
                            commit('setShipmentsPackages', response.data.shipments_packages)
                            commit('setShipmentsPackagesLiteLoad', true)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                           dispatch('fetchShipmentsPackagesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchShipmentsPackages/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsPackages', args, time: Date.now() / 1000})

                const params = getApiProps('shipmentsPackages', args)
                this.$api.shipmentsPackages.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsPackages', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsPackage/*all*/({dispatch, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                let args = {id}
                dispatch('setLastCall', {name: 'fetchShipmentsPackage', args, time: Date.now() / 1000})

                const params = getApiProps('shipmentsPackages', args)
                this.$api.shipmentsPackages.find(id,{...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error && !response.data.errors) {
                            commit('updateShipmentsPackage', response?.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsPackage', args, inprogress: false})
                    });
            })
        },

        fetchShipmentsPackagesAll({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isShipmentsPackagesLiteLoad) {
                    return resolve(getters.getShipmentsPackages.length)
                }
                dispatch('fetchShipmentsPackages', {lite: true})
                    .then((data) => {
                        commit('updateShipmentsPackages', data)
                        commit('setShipmentsPackagesLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchShipmentsPackagesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchShipmentsPackagesAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchShipmentsPackagesAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchShipmentsPackagesChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                if (!getters.getShipmentsPackages.length) {
                    return resolve([])
                }
                let pageSize = consts.querySettings.pageSize
                let pages = Math.ceil(getters.getShipmentsPackages.length / pageSize)
                let fetch = range(pages).map(i => {
                    let page = i + 1;
                    return dispatch('fetchShipmentsPackages', {page, 'page-size': pageSize, ...args})
                        .then((data) => {
                            commit('updateShipmentsPackages', data)
                        })
                        .catch(() => {
                            dispatch('fetchShipmentsPackages', {page, 'page-size': pageSize, ...args})
                        })
                });
                resolve(fetch)
            })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setShipmentsPackagesFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchShipmentsPackagesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchShipmentsPackagesChanged', args, inprogress: false})
                })
        },
        fetchShipmentsPackagesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isShipmentsPackagesFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchShipmentsPackagesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchShipmentsPackages', args)
                .then((data) => {
                    commit('updateShipmentsPackages', data)
                    return dispatch('fetchShipmentsPackages', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterShipmentsPackages', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchShipmentsPackagesChanged', args, inprogress: false})
                });
        },

        saveShipmentsPackage({dispatch}, shPackage) {
            let fn = (shPackage.id) ? 'updateShipmentsPackage' : 'createShipmentsPackage'
            return dispatch(fn, shPackage);
        },
        createShipmentsPackage({commit}, shPackage) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsPackages')
                this.$api.shipmentsPackages.create(shPackage, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateShipmentsPackage', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateShipmentsPackage({commit}, shPackage) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsPackages')
                this.$api.shipmentsPackages.update(shPackage.id, shPackage, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateShipmentsPackage', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteShipmentsPackage({commit}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsPackages')
                this.$api.shipmentsPackages.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteShipmentsPackage', id)
                            else commit('updateShipmentsPackage', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setShipmentsPackagesFullLoad(state, FullLoad) {
            state.shipmentsPackagesFullLoad = state.shipmentsPackagesFullLoad || FullLoad
        },
        setShipmentsPackagesLiteLoad(state, LitaLoad) {
            state.shipmentsPackagesLiteLoad = state.shipmentsPackagesLiteLoad || LitaLoad
        },

        setShipmentsPackages(state, nShipmentsPackages) {
            nShipmentsPackages = nShipmentsPackages.map(p => {
                if (p?.name) p.name_ = p.name.toLocaleLowerCase()
                return p //Object.freeze(p)
            })
            nShipmentsPackages.sort(sortByName)
            state.shipmentsPackages = nShipmentsPackages
        },

        updateShipmentsPackages(state, nShipmentsPackages) {
            if (!state.shipmentsPackages.length) {
                nShipmentsPackages = nShipmentsPackages.map(p => {
                    if (p?.name) p.name_ = p.name.toLocaleLowerCase()
                    return p //Object.freeze(p)
                })
                nShipmentsPackages.sort(sortByName)
                state.shipmentsPackages = nShipmentsPackages
                // const chunks = arraySplitIntoChunks(nShipmentsPackages)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.shipmentsPackages.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nShipmentsPackages.forEach(function (nPackage) {
                if (nPackage?.name) nPackage.name_ = nPackage.name.toLocaleLowerCase()
                let i = state.shipmentsPackages.findIndex(p => (p.id == nPackage.id))
                if (i < 0) {
                    state.shipmentsPackages.push(nPackage) //(Object.freeze(nPackage))
                } else
                if (!state.shipmentsPackagesFullLoad || (state.shipmentsPackages[i][changedField] != nPackage[changedField] && state.shipmentsPackages[i][changedField]>0)) {
                    updateObjectByDiff(state.shipmentsPackages[i], nPackage)
                    // delete nPackage.id
                    // nPackage = {...state.shipmentsPackages[i], ...nPackage}
                    // state.shipmentsPackages[i] = nPackage //Object.freeze(nPackage)
                }
            })

        },
        filterShipmentsPackages(state, nShipmentsPackages) {
            // let Ids = state.shipmentsPackages.map(p=> p.id)
            let nIds = nShipmentsPackages.map(p => p.id)
            let removedIds = state.shipmentsPackages.filter(p => p.id > 0 && !nIds.includes(p.id)).map(p => p.id)
            removedIds.forEach(removedId => {
                let i = state.shipmentsPackages.findIndex(p => (p.id == removedId))
                if (i != -1) {
                    state.shipmentsPackages.splice(i, 1)
                }
            })
        },
        updateShipmentsPackage(state, nPackage) {
            if (nPackage?.name) nPackage.name_ = nPackage.name.toLocaleLowerCase()
            let i = state.shipmentsPackages.findIndex(p => (p.id == nPackage.id))
            if (i < 0) {
                state.shipmentsPackages.push(nPackage) //(Object.freeze(nPackage))
            } else
            //if (!state.shipmentsPackagesFullLoad || (state.shipmentsPackages[i][changedField] != nPackage[changedField])) // && state.shipmentsPackages[i][changedField]>0
            {
                updateObjectByDiff(state.shipmentsPackages[i], nPackage)
                // delete nPackage.id
                // nPackage = {...state.shipmentsPackages[i], ...nPackage}
                // state.shipmentsPackages[i] = nPackage //Object.freeze(nPackage)
            }
        },
        deleteShipmentsPackage(state, id) {
            let i = state.shipmentsPackages.findIndex(p => (p.id == id))
            if (i != -1) {
                state.shipmentsPackages.splice(i, 1)
            }
        },

        clearShipmentsPackages(state) {
            state.shipmentsPackages = []
            state.shipmentsPackagesFullLoad = false
            state.shipmentsPackagesLiteLoad = false
        },
    },
    getters: {
        isShipmentsPackagesFullLoad(state) {
            return state.shipmentsPackagesFullLoad
        },
        isShipmentsPackagesLiteLoad(state) {
            return state.shipmentsPackagesLiteLoad
        },
        getShipmentsPackagesFullLoadById(state) {
            return state.shipmentsPackages.reduce((out, shPackage) => {
                out[shPackage.id] = (typeof shPackage[changedField] !== 'undefined')
                return out
            }, {})
        },
        getLockedShipmentsPackages(state) {
            return state.shipmentsPackages.filter(p => (p.id > 0) && (p[changedField] < 0)).map(p => p.id)
        },
        getShipmentsPackages(state) {
            return state.shipmentsPackages
        },
        getShipmentsPackagesById(state) {
            return state.shipmentsPackages
                .reduce((packages, shPackage) => {
                    packages[shPackage.id] = shPackage
                    return packages
                }, {})
        },
    }
}
